import React from "react";
import { useObserver } from "mobx-react-lite";
import { ProjectDirectoryModel } from "./ProjectDirectoryModel";
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from "@material-ui/core";
import { DarwinInput } from "Globals/Styles/Control/DarwinInput";
import { AcceptButton } from "Globals/Styles/Control/Buttons";
import { ProjectDirectoryViewModel } from "./ProjectDirectoryViewModel";

interface IEditDirectoryEntryModalProps {
    open: boolean;
    onClose: () => void;
    onSave: (entry: ProjectDirectoryModel) => Promise<void>;
    entry: ProjectDirectoryModel;
    isLoading: boolean;
}

export const EditDirectoryEntryModal: React.FC<IEditDirectoryEntryModalProps> = ({ open, onClose, onSave, entry, isLoading }) => {
    const [viewModel] = React.useState(() => {
        const vm = new ProjectDirectoryViewModel();
        vm.setModel(entry);
        return vm;
    });

    React.useEffect(() => {
        viewModel.setModel(entry);
    }, [entry]);

    const handleSave = async () => {
        await onSave(viewModel.model);
    };

    return useObserver(() => (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Edit person</DialogTitle>
            <DialogContent>
                <Box p={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="First Name"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="firstName"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Last Name"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="lastName"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Company"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="company"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Role"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="role"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Email Address"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="emailAddress"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DarwinInput<ProjectDirectoryViewModel>
                                type="text"
                                label="Phone Number"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="phoneNumber"
                                shrink={true}
                                maxLength={255}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <AcceptButton onClick={handleSave} disabled={isLoading}>
                    Save
                </AcceptButton>
                <AcceptButton onClick={onClose}>Cancel</AcceptButton>
            </DialogActions>
        </Dialog>
    ));
};
